import { observer, inject } from "mobx-react";
import { AuthRoute } from "@vidazoo/ui-framework";

export default inject((stores: any, props: any, context: any): any => ({
	isAuthenticated: stores.sessionStore.isAuthenticated,
	isInRoles: stores.currentUserStore.isInRoles
}))(AuthRoute);
